import{ReservationCategorylistComponent}from '../components/ReservationCategory/reservation-categorylist.component';
import { Injectable,Component } from '@angular/core';
import { HttpHeaders}  from '@angular/common/http';  
import { Observable,throwError  } from 'rxjs';  
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class GridColumns {
  caption: string;
  dataField: string;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
};
export class Reservationcategory {
  ReservationCategoryID:number;
  ReservationCategoryType:string;
  ReservationCategoryName: string;
  ReservationCategoryShortName: string;
  ReservationCategoryCode:string;
  CreatedLoginID:number;
  UpdatedLoginID:number;  
}
export class Type{
  ReservationCategoryType:string;
  ReservationCategoryTypeName:string;
}
let types:Type[]=[{
  "ReservationCategoryType":"O",
  "ReservationCategoryTypeName":"Open"
},{
  "ReservationCategoryType":"R",
  "ReservationCategoryTypeName":"Reserved"
}
 ]; 
let gridColumns: GridColumns[] = [{
  "caption": 'Type',
  "dataField":"ReservationCategoryTypeName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Name',
  "dataField": "ReservationCategoryName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Short Name',
  "dataField": "ReservationCategoryShortName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Code',
  "dataField": "ReservationCategoryCode",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
}
];

@Injectable(
  {  
    providedIn: 'root'  
  }
)
@Component({
  providers: [DataAccessService]
})

export class ReservationcategoryService {
  constructor(
    private dataService: DataAccessService) { 
  }
  public ReservationcategoryData: Reservationcategory;
  public errormsg;
  public successmsg;
  public getAllReservationcategory() {
    this.dataService.setControllerName = '/BasicReservationCategory/';
    this.dataService.setMethodName = 'GetBasicReservationCategoryList?ReservationCategoryID=0'; // setting method name from API controller.
    return this.dataService.getAll<Reservationcategory[]>()
  }  
  public getAllReservationcategoryList() {
    this.dataService.setControllerName = '/BasicReservationCategory/';
    this.dataService.setMethodName = 'GetBasicReservationCategoryList?ReservationCategoryID=0'; // setting method name from API controller.
    return this.dataService.getAll<Reservationcategory[]>()
  }   
  public getAllSocialList() {
    this.dataService.setControllerName = '/BasicReservationCategory/';
    this.dataService.setMethodName = 'GetBasicSocialReservationCategory'; // setting method name from API controller.
    return this.dataService.getAll<Reservationcategory[]>()
  }   
  public geReservationcategoryByID() { 
    this.dataService.setControllerName = '/BasicReservationCategory/';
    this.dataService.setMethodName = 'GetBasicReservationCategoryList';
    this.dataService
      .getSingle<Reservationcategory>('?ReservationCategoryID=0')    
      .subscribe((data: Reservationcategory) => this.ReservationcategoryData = data,
        error => () => {
        },
        () => {
              return this.ReservationcategoryData;
        });
  }  
  public save(data) {
    this.dataService.setControllerName = '/BasicReservationCategory/';
    this.dataService.setMethodName = 'PostInsertBasicReservationCategory'; // setting method name from API controller.
    return this.dataService.add<Reservationcategory[]>(data) 
  }
  public update(data) {
    this.dataService.setControllerName = '/BasicReservationCategory/';
    this.dataService.setMethodName = 'PostBasicReservationCategory'; // setting method name from API controller.
    return this.dataService.add<Reservationcategory[]>(data)
  }
  public delete(data) {
    this.dataService.setControllerName = '/BasicReservationCategory/';
    this.dataService.setMethodName = 'PostDeleteBasicReservationCategory'; // setting method name from API controller.
    return this.dataService.delete<Reservationcategory[]>(data)
  }
 
  getGridColumns() {
    return gridColumns;
  }
getType() {
  return types;
}
}



